<template>
  <v-detail :label="label" :field="field" :value="value" custom-editable>
    <button class="g-pseudo-link" @click="openModal">{{ buttonLabel }}</button>

    <v-modal :name="field" class="modal" :width="750" height="auto" scrollable close-button>
      <h2 class="modal__heading">{{ label }}</h2>

      <form class="modal__form">
        <v-checkbox v-if="editMode" :value="Boolean(useDefaultDraft)" @input="useDefaultDraft = Number($event)">
          {{ $t('USE_DEFAULT') }}
        </v-checkbox>

        <editable-markdown :value="useDefaultDraft && editMode ? defaultValue : valueDraft"
          :disabled="Boolean(useDefaultDraft)" @input="valueDraft = $event" />

        <div>
          <v-button v-if="editMode" @click.native.prevent="save">{{ $t('SAVE') }}</v-button>
        </div>
      </form>
    </v-modal>
  </v-detail>
</template>

<script>
import detailsViewMixin from '@/mixins/detailsView.js';
import VModal from '@/components/VModal.vue';
import VButton from '@/components/Button.vue';
import VCheckbox from '@/components/Checkbox.vue';
import EditableMarkdown from './EditableMarkdown.vue';
import VDetail from './VDetail.vue';

export default {
  props: {
    field: {
      type: String,
    },
    label: {
      type: String,
    },
    useDefault: {
      type: Number,
    },
    defaultValue: {
      type: String,
    },
    value: {
      type: String,
    },
  },
  mixins: [detailsViewMixin],
  components: {
    VDetail, VModal, EditableMarkdown, VButton, VCheckbox,
  },
  data() {
    return {
      valueDraft: this.value,
      useDefaultDraft: this.useDefault,
    };
  },
  computed: {
    buttonLabel() {
      if (this.editMode) {
        return this.$t('EDIT');
      }

      return this.$t('VIEW');
    },
  },
  methods: {
    openModal() {
      this.reset();
      this.$modal.show(this.field);
    },
    reset() {
      this.valueDraft = this.value;
      this.useDefaultDraft = this.useDefault;
    },
    save() {
      if (this.useDefaultDraft) {
        this.$emit('update:use-default', 1);
        this.$emit('input', '');
      } else {
        this.$emit('update:use-default', 0);
        this.$emit('input', this.valueDraft);
      }

      this.$modal.hide(this.field);
    },
  },
};
</script>

<style lang="scss" scoped>
.modal {
  &__heading {
    font-size: 20px;
    font-weight: 500;
  }

  &__form {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
}
</style>
